function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.236 2h7.528a.91.91 0 01.642.266l5.328 5.328a.91.91 0 01.266.642v7.528a.91.91 0 01-.266.642l-5.328 5.328a.91.91 0 01-.642.266H8.236a.91.91 0 01-.642-.266l-5.328-5.328A.91.91 0 012 15.764V8.236a.91.91 0 01.266-.642l5.328-5.328A.91.91 0 018.236 2zm.377 1.818L3.818 8.613v6.774l4.795 4.795h6.774l4.795-4.795V8.613l-4.795-4.795H8.613zm2.478 4.546a.91.91 0 011.818 0V12a.91.91 0 01-1.818 0V8.364zm.266 7.006a.91.91 0 111.286-1.286.91.91 0 01-1.286 1.286z"
});

var SvgAlertOctagon = function SvgAlertOctagon(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/alert-octagon.65605c87.svg";
export { SvgAlertOctagon as ReactComponent };